import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import axios from "axios";

export default {
    name: "resumeDetail",
    components: {
        MainLayout
    },

    data() {
        return {
            fromRoute: null,
            fromJobId: null,
            resume: {
                id: "",
                name: "",
                path: "",
                nrc_number: "",
                nationality: "",
                religion: "",
                phone_number: "",
                email: "",
                facebook: "",
                linkin: "",
                gender: "",
                marital_status: "",
                date_of_birth: "",
                contact_address: "",
                permanent_address: "",
                position: "",
                expected_salary: "",
                education_detail: "",
                other_certificate: "",
                experience_detail: ""
            }
        };
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from && from.name) {
                vm.fromRoute = from.name;
                if (from.params && from.params.id) {
                    vm.fromJobId = from.params.id;
                }
            }
        });
    },

    computed: {
        backRoute() {
            const jobId = this.$route.query.job_id || this.fromJobId;
            if ((this.fromRoute === "applyIndex" || this.$route.query.from === "applyIndex") && jobId) {
                return { name: "applyIndex", params: { id: jobId } };
            }
            return { name: "applicantIndex" };
        }
    },

    methods: {
        goBack() {
            if (window.history.length > 1 && (this.fromRoute || this.$route.query.from)) {
                this.$router.go(-1);
            } else {
                const jobId = this.$route.query.job_id || this.fromJobId;
                if ((this.fromRoute === "applyIndex" || this.$route.query.from === "applyIndex") && jobId) {
                    this.$router.push({ name: "applyIndex", params: { id: jobId } });
                } else {
                    this.$router.push({ name: "applicantIndex" });
                }
            }
        },

        getResumeDetail() {
            axios.get("/applicant/resume/detail/" + this.$route.params.id)
                .then(response => {
                    if (!response.data || !response.data.id) {
                        this.$router.push({ name: "notFound" });
                        return;
                    }
                    this.resume = response.data;
                })
                .catch(() => {
                    this.$router.push({ name: "notFound" });
                });
        }
    },

    mounted() {
        this.getResumeDetail();
    }
};